<template>
  <v-dialog v-model="showDialog" :max-width="1500" :persistent="loading">
    <v-card class="pa-1">
      <div class="text-right d-flex text-white bg-black pa-2">
        <div class="text-left pa-0">
          Participacion / Divisiones - {{ charTitle }}
        </div>
        <v-icon
          class="ml-auto"
          size="20"
          color="#fff"
          :disabled="loading"
          @click="showDialog = false"
        >
          mdi-close-circle
        </v-icon>
      </div>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="5">
            <div class="text-left pa-1 pa-sm-0">
              Trimestre
              <custom-select
                v-model="period"
                value="1"
                :options="periods"
                :placeholder="'Trimestral'"
                :disabled="loading"
                @input="periodChanged"
              />
            </div>
            <v-progress-circular v-if="loading" indeterminate color="primary" />
            <pie-chart
              v-if="!loading"
              :chartdata="pieData"
              style="width: 100%"
            />
          </v-col>
          <v-col cols="12" sm="7">
            <v-breadcrumbs divider="/">
              <template v-if="divisions.isSubDivision">
                <v-breadcrumbs-item>
                  <v-icon
                    color="error"
                    style="cursor: pointer"
                    @click="resetFilters"
                  >
                    mdi-alpha-x-circle
                  </v-icon>
                </v-breadcrumbs-item>
              </template>
              <v-breadcrumbs-item
                v-for="(item, index) in breadcrumbItems"
                :key="index"
              >
                {{ item.text }}
              </v-breadcrumbs-item>
            </v-breadcrumbs>
            <v-simple-table dense>
              <template #default>
                <thead class="table-heading">
                  <tr>
                    <th class="text-center" style="color: #00b99d">
                      Facturación<br />bruta
                    </th>
                    <th class="text-center text-dark">
                      <span style="color: #ff9f00">
                        %&nbsp;de<br />participación
                      </span>
                    </th>
                    <th class="text-center text-dark">
                      <span
                        v-if="divisions.isSubDivision && !divisions.isGroup"
                        style="color: #746ee5"
                      >
                        Subdivisiones
                      </span>
                      <span
                        v-else-if="divisions.isGroup"
                        style="color: #746ee5"
                      >
                        Grupos de Mat.
                      </span>
                      <span v-else style="color: #746ee5"> Divisiones </span>
                    </th>
                  </tr>
                </thead>
                <tbody v-if="!loading" class="custom-table-bordered">
                  <tr
                    v-for="(item, index) in recordData"
                    :key="index"
                    :class="index % 2 == 0 ? 'cell-bg-gray' : ''"
                  >
                    <td>{{ formatNumber(item.amount, '$', 0) }}</td>
                    <td>{{ formatFloat(item.percentage ?? 0) }}%</td>
                    <td>
                      <a
                        v-if="!divisions.isGroup"
                        class="text-decoration-underline"
                        @click="onDivisionClick(item.name)"
                      >
                        {{ item.name }}
                      </a>
                      <span v-else> {{ item.name }} </span>
                    </td>
                  </tr>
                  <tr v-if="total > 0" class="font-weight-bold bg-gray">
                    <td>{{ formatNumber(total, '$', 0) }}</td>
                    <td>{{ formatFloat(totalPercent, 0) }}%</td>
                    <td colspan="2">Total</td>
                  </tr>
                  <tr v-if="recordData.length < 1">
                    <td colspan="3">
                      <span class="text--disabled">
                        No se encontraron datos
                      </span>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="3">
                      <v-progress-linear
                        class="mt-3"
                        indeterminate
                        color="teal"
                      />
                      <span class="text--disabled"> Cargando información</span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <alert-prominent v-if="errors" :message="errors" :dismissible="true" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  import PieChart from '../../components/PieChart.vue';
  import CustomSelect from '@/components/CustomSelect.vue';
  import mixinService from '@/mixins/service.js';
  import helpers from '@/mixins/helpers';
  import AlertProminent from '@/components/AlertProminent.vue';
  import numbersFormats from '@/mixins/numbersFormats';
  import ColorGenerator from '@/utilities/color-generator';

  export default {
    name: 'Graph',
    components: {
      PieChart,
      CustomSelect,
      AlertProminent,
    },
    mixins: [mixinService, helpers, numbersFormats],
    props: {
      data: {
        default: [],
      },
      defaultPeriod: {
        default() {
          let currentMonth = new Date().getMonth() + 1;
          let trim = Math.ceil(currentMonth / 3);
          let currentYear = new Date().getFullYear();
          return trim + '-' + currentYear;
        },
      },
      value: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: true,
      },
      errors: {
        default: '',
      },
      charTitle: {
        default() {
          return 'Detalle de zona';
        },
      },
    },
    data: () => ({
      period: '',
      recordData: [],
      periods: [],
      pieData: {},
      total: 0,
      totalPercent: 0,
      divisions: {
        isSubDivision: false,
        subdivisionSelected: '',
        isGroup: false,
        groupSelected: '',
        division: '',
      },
      breadcrumbItems: [],
    }),
    computed: {
      showDialog: {
        set(value) {
          this.$emit('input', value);
        },
        get() {
          return this.value;
        },
      },
    },
    watch: {
      data() {
        this.recordData = [...this.data].sort((a, b) => {
          return parseFloat(b.percentage) - parseFloat(a.percentage);
        });
        this.getDataChart();
      },
      value(value) {
        if (value) this.divisions.isSubDivision = false;
      },
    },
    mounted() {
      this.periods = this.getQuartersList(5);
      this.period = this.periods[0].value;
    },
    methods: {
      resetFilters() {
        this.recordData = this.data;
        this.breadcrumbItems = [];
        this.initDivisions();
        this.getDataChart();
      },
      onDivisionClick(division) {
        if (this.divisions.isSubDivision) {
          this.recordData = this.getMatGroups(division);
          this.divisions.isGroup = true;
        } else {
          this.divisions.isSubDivision = true;
          this.subdivisionSelected = division;
          this.recordData = this.getSubdivisions(division);
        }

        this.recordData.sort((a, b) => {
          return parseFloat(b.percentage) - parseFloat(a.percentage);
        });

        this.breadcrumbItems.push({
          text: division,
        });
        this.getDataChart();
      },
      getSubdivisions(division) {
        const subdivisions = this.data.find((d) => d.name === division);
        if (subdivisions && subdivisions.subdivisions) {
          return subdivisions.subdivisions.sort((a, b) => {
            return parseFloat(b.percentage) - parseFloat(a.percentage);
          });
        }
        return [];
      },
      getMatGroups(subdivision) {
        const groups = this.recordData.find((s) => s.name === subdivision);
        if (groups && groups.groups) {
          return groups.groups.sort((a, b) => {
            return parseFloat(b.percentage) - parseFloat(a.percentage);
          });
        }
        return [];
      },
      periodChanged() {
        const arrayPeriod = this.period.split('-');
        const period = {
          year: arrayPeriod[0],
          quarter: arrayPeriod[1],
          division: this.divisions.division,
        };
        this.recordData = [];
        this.$emit('onPeriodChange', period);
        this.initDivisions();
      },
      initDivisions() {
        this.breadcrumbItems = [];
        this.divisions = {
          isSubDivision: false,
          subdivisionSelected: '',
          isGroup: false,
          groupSelected: '',
          division: '',
        };
      },
      getDataChart() {
        this.pieData = {};
        const pluck = (arr, key) =>
          arr.map((i) => parseFloat(i[key]).toFixed(2));
        const labels = (arr, key) => arr.map((i) => i[key]);
        const percent = pluck(this.recordData, 'percentage');
        this.total = this.arraySum(pluck(this.recordData, 'amount'));
        this.totalPercent = this.arraySum(pluck(this.recordData, 'percentage'));
        const labl = labels(this.recordData, 'name');
        const colors = ColorGenerator.getRandomColors(percent.length, {
          pastel: false,
          alpha: false,
        });
        this.pieData = {
          datasets: [
            {
              backgroundColor: colors,
              data: percent,
            },
          ],
          labels: labl,
        };
      },
    },
  };
</script>
